<div class="productDetailsPrice">
  <p class="productDetailsPrice__main">
    {{'productDetails.price.currentPrice' | translate}}: <strong>{{priceInformations.discountPrice ? priceInformations.discountPrice.formattedValue : priceInformations.price.formattedValue}}</strong>
  </p>
  <p *ngIf="priceInformations.lowestProductPrice" class="productDetailsPrice__lowest">
    <span [innerHTML]="('productDetails.price.lowestPrice' | translate)+': <strong>'+priceInformations.lowestProductPrice.formattedValue+'</strong>'"></span>
    <span  *ngIf="priceInformations.lowestProductPriceToDiscountPriceRatio" class="productDetailsPrice__percent">-{{priceInformations.lowestProductPriceToDiscountPriceRatio}}%</span>
  </p>
  <p>{{'productDetails.price.catalogPrice' | translate}}: <strong>{{priceInformations.price.formattedValue}}</strong></p>
</div>
